import { afterNextRender,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  NgZone,
  TemplateRef,
  ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mp-contextual-menu',
  imports: [
    CommonModule
  ],
  templateUrl: './mp-contextual-menu.component.html',
  styleUrls: ['./mp-contextual-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MpContextualMenuComponent {

  @ViewChild('contextualMenu', { read: ElementRef }) contextualMenuElementRef: ElementRef;

  @Input() anchor: ElementRef;
  @Input() mpContextualMenu: TemplateRef<any>;
  @Input() mpContextualMenuPosition: 'above' | 'below' | 'left' | 'right' = 'below';
  @Input() mpContextualMenuData: unknown;

  constructor(private readonly elementRef: ElementRef,
              private readonly ngZone: NgZone) {
    afterNextRender({ write: () => this.computePosition() });
  }

  private computePosition() {
    this.ngZone.runOutsideAngular(() => {
      const { right, top, bottom } = this.anchor.nativeElement.getBoundingClientRect();
      const maxWidth = window.innerWidth;
      const maxHeight = window.innerHeight;
      const dropDownMeasure = this.elementRef.nativeElement.children[0]?.getBoundingClientRect();

      if (bottom + dropDownMeasure.height > maxHeight - 10) {
        this.contextualMenuElementRef.nativeElement.style.top = `${top - dropDownMeasure.height + 1}px`;
      } else {
        this.contextualMenuElementRef.nativeElement.style.top = `${bottom}px`;
      }

      this.contextualMenuElementRef.nativeElement.style.left = `auto`;
      this.contextualMenuElementRef.nativeElement.style.right = `${maxWidth - right}px`;
    });

  }
}
